import { z } from 'zod';

export const UserTeamMemberManageModalSchema = z.object({
  members: z.array(z.string()).min(1, "メンバーを1人以上選択してください"),
});

export type UserTeamMemberManageModalData = z.infer<typeof UserTeamMemberManageModalSchema>;
